import { dataHooks } from '../../../libs/dataHooks';

export const filtersNoResultsDataHooks = dataHooks<{
  title: {};
  resetLink: {};
  description: {};
}>('no-filters-results');
